export const frontendTitle = 'Frontend Developer';
export const backendTitle = 'Backend Developer';
export const skillsSectionTitle = 'Skills';
export const skillsSectionSubtitle = 'My technical level';

export const backendSkills = [
    { name: "Java" },
    { name: "Spring Boot" },
    { name: "Maven" },
    { name: "REST" },
    { name: "Python" },
    { name: "Spring Framework" },
    { name: "Hibernate, JDBC" },
    { name: "SQL" },
];

export const frontendSkills = [
    { name: "Typescript" },
    { name: "React" },
    { name: "Bootstrap" },
    { name: "Styled Components" },
    { name: "JavaScript" },
    { name: "HTML" },
    { name: "CSS" },
    { name: "Mui, Chakra" },
];